/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentAllocationMethodRequest = {
    /**
     * value | volume | weight
     */
    allocationMethod: ShipmentAllocationMethodRequest.allocationMethod;
};
export namespace ShipmentAllocationMethodRequest {
    /**
     * value | volume | weight
     */
    export enum allocationMethod {
        VALUE = 'value',
        VOLUME = 'volume',
        WEIGHT = 'weight',
    }
}

